import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M19.71 8.57c1.71 0 2.93-1.06 3.43-2.52.22-.65.86-2.62.86-2.62-1.17 0-2.23.74-2.9 1.62-.13-1.16-.6-2.29-1.38-3.34-.78 1.04-1.25 2.18-1.38 3.34-.68-.88-1.74-1.62-2.9-1.62 0 0 .64 1.97.86 2.62.5 1.46 1.71 2.52 3.43 2.52h-.02Z" />
    <path d="M24 13.71C24 8.57 8.57 12 8.57 8.57c0-1.71 5.14-2.57 5.14-5.14C13.71 0 6 0 1.26 0 .56 0 0 .57 0 1.28c0 .71.58 1.29 1.29 1.3 3.51.02 5.57.18 5.57 1.71C6.86 6 0 6.86 0 10.29c0 4.29 10.29 1.71 10.29 4.29C10.29 16.29 0 17.15 0 21.44c0 2.49 4.29 2.57 8.57 2.57h14.14c.71 0 1.29-.58 1.29-1.29 0-.71-.58-1.29-1.29-1.29h-3c-2.57 0-6 0-6-1.77C13.71 17.09 24 18 24 13.71Z" />
  </>
);

const CollRivers = Icon('coll-rivers', svgContents);

export default CollRivers;
